<!-- Login unificado: el backend identifica el destino por el role del usuario. -->
<template>
  <main class="login-page">
    <LoginForm
      mode="page"
      :event-id="$route.query.event || null"
      :redirect="$route.query.redirect || null"
    />
  </main>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { isAmpiMember } from "@/common/memberDashboardRouting";
import LoginForm from "@/components/shared/LoginForm.vue";

export default {
  name: "UnifiedLogin",
  components: {
    LoginForm,
  },
  computed: {
    ...mapState("user", ["user"]),
  },
  methods: {
    ...mapActions("user", ["realoadUserData", "botTemporalAccess"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    isAmpiMember,
  },
  async created() {
    if (this.$route.params.token && this.$route.params.email) {
      this.loading();

      await this.botTemporalAccess({
        token: this.$route.params.token,
        id: this.$route.params.email,
      });

      const reloadResponse = await this.realoadUserData({ id: this.$route.params.email });

      this.loaded();

      if (!reloadResponse?.status) {
        this.$router.push("/login");
        return;
      }

      if (this.$route.params.eventId && reloadResponse.userState === "ACTIVE") {
        this.$router.push(`/member/eventMicrosite/${this.$route.params.eventId}`);
        return;
      }

      if (this.$route.params.eventId) {
        this.$router.push(`/micrositio/${this.$route.params.eventId}`);
        return;
      }

      const routes = this.isAmpiMember(this.user)
        ? {
            homeLogin: "/member/home",
            communityLogin: "/member/community",
            benefitsLogin: "/member/benefits",
            myInfoLogin: "/member/home/showInfo",
            eventsLogin: "/member/events",
          }
        : {
            homeLogin: "/member-v2/home",
            communityLogin: "/member-v2/community",
            benefitsLogin: "/member-v2/benefits",
            myInfoLogin: "/member-v2/profile",
            eventsLogin: "/member-v2/events",
          };

      if (this.$route.name in routes) {
        this.$router.push(routes[this.$route.name]);
      } else {
        const link = `/member/renew/2/${this.user._id}`;
        const branch = this.user.branchId;
        this.$router.push(
          `${link}${
            !["N/D", "N/A", null].includes(branch) &&
            this.user.headOffice.paymentType != "NATIONAL"
              ? "/" + branch
              : ""
          }`
        );
      }
    }
  },
  mounted() {
    this.$gtag.screenview({
      app_name: "App",
      screen_name: "Login page",
    });
  },
};
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

@media (max-width: 820px) {
  .login-page {
    overflow: auto;
  }
}
</style>
